//unuse component
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../api";
const AddUser = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    // if (!formData.name.trim()) newErrors.name = 'Name is required';
    // if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) newErrors.email = 'Valid email is required';
    // if (!formData.phone.match(/^[0-9]{10}$/)) newErrors.phone = '10-digit phone number required';
    if (!formData.username.trim()) newErrors.username = "Username is required";
    if (!formData.password.length > 6)
      newErrors.password = "Password must be at least 6 characters";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = async (e) => {
    const token = localStorage.getItem("token");
    e.preventDefault();
    if (!validate()) return;

    try {
      const res = await api.post("/adduser", formData);
      //   {
      //   body: JSON.stringify(formData),
      // });

      const data =  res.data;
      if (res.status===200 || res.status === 201) {
        //localStorage.setItem('token', data.token);
        toast.success("User created successfully!");
        setFormData({ username: "", password: "" });
        //toast.success("User created successfully!");
        navigate("/users");
      } else {
        toast.error(data.error || "Failed to create user.");
        console.log(data.error);
      }
    } catch (err) {
      toast.error("Server error");
      console.error(err);
    }
  };

  return (
    <>
    
        <div className='loginTrBg afterLogin'>
    <div className="loginTrBgIn">
          <Card className="border-0 rounded">
            <Card.Body>
            <div className='loginTitleWrap'>
              <h5 className="text-center">Add New User Form</h5>
            </div>
            {/* <h3 className="text-center mb-4">Add New User Form</h3> */}
            <Form noValidate onSubmit={handleSubmit}>
              {/* Name
                <Form.Group className="mb-3" controlId="name">
                <Form.Label>Name</Form.Label>
                <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                </Form.Group> */}

              {/* Email */}
              {/* <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                </Form.Group> */}

              {/* Phone */}
              {/* <Form.Group className="mb-3" controlId="phone">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    isInvalid={!!errors.phone}
                />
                <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback>
                </Form.Group> */}

              {/* Username */}
              <Form.Group className="form-group" controlId="username">
                <Form.Label>Username</Form.Label>
                <Form.Control
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  isInvalid={!!errors.username}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.username}
                </Form.Control.Feedback>
              </Form.Group>

              {/* Password */}
              <Form.Group className="form-group" controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  isInvalid={!!errors.password}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="text-center">
                <Button
                  variant="primary"
                  type="submit"
                  className="btn btn-dark w-100"
                >
                  Register
                </Button>
              </div>
            </Form>
            </Card.Body>
          </Card>
        </div>
      </div>
    
    </>
  );
};

export default AddUser;
